var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useMemo } from 'react';
import { Button, Icon, Form } from 'semantic-ui-react';
import { reportError, AuthorWidget, } from '..';
import dayjs from 'dayjs';
import { CommentsList, PostCommentWidget } from './Comments';
import './Story.css';
import './commonStyles.css';
import cx from 'classnames';
import { LikeWidget } from './LikeWidget';
export var Story = function (_a) {
    var item = _a.item, user = _a.user, expanded = _a.expanded, onClick = _a.onClick, onVote = _a.onVote, onComment = _a.onComment, onClose = _a.onClose;
    var author = item.author, title = item.title, description = item.description, created = item.created, userVoted = item.userVoted, votes = item.votesCount, comments = item.comments;
    var _b = useState(false), showCommentsWidget = _b[0], setShowCommentsWidget = _b[1];
    var commentsCount = (comments === null || comments === void 0 ? void 0 : comments.length) || 0;
    var sortedComments = useMemo(function () {
        if (!comments)
            return comments;
        return comments.sort(function (l, r) { return (l.created < r.created ? -1 : 1); });
    }, [comments]);
    var icon = 'edit outline';
    return (React.createElement("div", { className: cx({ item: true, 'story-item': true, expanded: expanded }), onClick: onClick },
        React.createElement("div", { className: "title" },
            React.createElement(Icon, { name: icon }),
            title),
        expanded && (React.createElement("div", { className: "author-created" },
            React.createElement(AuthorWidget, { userId: author, watchForChanges: true }),
            ' on ',
            new Date(created).toLocaleString())),
        React.createElement("br", null),
        expanded && description !== title && (React.createElement("section", { className: "description" }, description)),
        !!commentsCount && (React.createElement("div", { className: "replies-count" },
            commentsCount,
            " replies")),
        React.createElement("div", { className: "actions" },
            React.createElement(LikeWidget, { votes: votes, userVoted: userVoted, onVote: onVote }),
            React.createElement("div", null,
                expanded && (user === null || user === void 0 ? void 0 : user.uid) === author && (React.createElement(Button, { icon: "close", content: "Delete", basic: true, onClick: function () {
                        if (window.confirm('Are you sure you want to close it?'))
                            onClose().catch(reportError);
                    } })),
                !showCommentsWidget && !expanded && (React.createElement(Button, { basic: true, onClick: function (e) {
                        e.stopPropagation();
                        setShowCommentsWidget(true);
                    } }, "Reply")))),
        expanded && !!commentsCount && (React.createElement("section", null,
            React.createElement("h4", { className: "pale-heading" }, "Replies"),
            React.createElement(CommentsList, { comments: sortedComments }))),
        (showCommentsWidget || expanded) &&
            (!!user ? (React.createElement(PostCommentWidget, { onComment: onComment })) : (React.createElement("div", { style: { textAlign: 'center' } }, "You need to register or sign in to be able to post")))));
};
export var AddNewStoryObject = function (_a) {
    var type = _a.type, onPost = _a.onPost;
    var _b = useState({ valid_until: 12 * 60 }), state = _b[0], setState = _b[1];
    var onChange = function (e) {
        var _a;
        var _b = e.target, name = _b.name, value = _b.value;
        console.debug(e.target.name, e.target.value);
        setState(__assign(__assign({}, state), (_a = {}, _a[name] = value, _a)));
    };
    return (React.createElement("div", { className: "add-new-story" },
        React.createElement("h4", null,
            React.createElement(Icon, { name: "edit outline" }),
            " Create story"),
        React.createElement(Form, { onSubmit: function (e) {
                e.preventDefault();
                console.debug('submit', state);
                var topic = state.topic, message = state.message, valid_until = state.valid_until;
                onPost({
                    type: type,
                    title: topic || message,
                    description: message,
                    valid_until: dayjs().add(valid_until, 'minute').toISOString(),
                });
            } },
            React.createElement(Form.Input, { autoComplete: "off", label: "Subject", name: "topic", onChange: onChange }),
            React.createElement(Form.TextArea, { autoFocus: true, label: "Story", name: "message", onChange: onChange }),
            React.createElement(Form.Button, { primary: true }, "Post"))));
};
//# sourceMappingURL=Story.js.map